<template>
  <div class="box-body" style="padding-top: 20px;">
    <i class="el-icon-refresh" @click="reload()" style="position: absolute;top: 10px;right: 10px;cursor: pointer;font-size: 18px;"></i>
    <i class="el-icon-setting" @click="showSettingDialog" style="position: absolute;top: 10px;right: 40px;cursor: pointer;font-size: 18px;"></i>
    <div class="product-list-box" v-for="(product,$index) in dataList" :key="product.id">
      <div class="table-bar" style="margin-bottom: 0px;">
        <div class="title">
          <span>{{ getProductName(product) }}</span>
          <span style="margin-left: 20px;">发货数：{{ product.checkOutCount }}</span>
        </div>
        <div v-if="product.hasBom" style="padding-right: 20px;">
          <el-button type="primary" size="mini" @click="batchSaveBom(product)">批量保存</el-button>
          <el-button type="primary" size="mini" @click="saveBomForSettle(product.bomList)">保存</el-button>
        </div>
      </div>
      <el-form
          :model="product"
          ref="dataForm"
          label-width="0"
      >
        <el-table :data="product.bomList" :summary-method="getSummaries" :id="'table'+$index" :loading="dataListLoading"
                  show-summary>
          <el-table-column label="品名" min-width="120" align="center" prop="name" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
              label="颜色"
              prop="color"
              header-align="center"
              align="center"
              min-width="100"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              label="规格"
              prop="size"
              header-align="center"
              align="center"
              min-width="100"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              label="幅宽"
              prop="attr1"
              header-align="center"
              align="center"
              min-width="100"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              label="克重"
              prop="attr2"
              header-align="center"
              align="center"
              min-width="100"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              label="理论单耗"
              prop="count"
              header-align="center"
              align="center"
              width="100"
          >
          </el-table-column>
          <el-table-column
              label="实际单耗"
              prop="realCount"
              header-align="center"
              align="center"
              width="100"
          >
            <template #default="{row,$index}">
              <el-form-item
                  v-if="row.type==='bom'&&!exporting"
                  :prop="'bomList.' + $index + '.realCount'"
                  :rules="detailRule.count"
                  style="margin-bottom: 0"
              >
                <el-input v-if="row.type==='bom'" size="mini" v-model="row.realCount"></el-input>
              </el-form-item>
              <div v-else v-text="row.realCount"></div>
            </template>
          </el-table-column>
          <el-table-column
              label="开票单价"
              prop="price"
              header-align="center"
              align="center"
              width="100"
          >
          </el-table-column>
          <el-table-column
              label="调整金额"
              prop="otherAmount"
              header-align="center"
              align="center"
              width="100"
          >
            <template #default="{row,$index}">
              <el-form-item
                  v-if="row.type==='bom'&&!exporting"
                  :prop="'bomList.' + $index + '.otherAmount'"
                  :rules="detailRule.money"
                  style="margin-bottom: 0"

              >
                <el-input size="mini" v-model="row.otherAmount"></el-input>
              </el-form-item>
              <div v-else v-text="row.otherAmount"></div>
            </template>
          </el-table-column>
          <el-table-column
              label="金额"
              prop="totalPrice"
              header-align="center"
              align="center"
              width="100"
          >
          </el-table-column>
        </el-table>
      </el-form>
    </div>
    <SelOrderDetailDialog ref="SelOrderDetailDialog" @change="getDataList()"
                          @selected="orderDetailSelected"></SelOrderDetailDialog>
    <el-dialog
        :visible.sync="settingDialogVisible"
        title="品番显示设置"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="500px"
    >
      <el-checkbox-group v-model="productNameSetting">
        <el-checkbox label="code">品番号</el-checkbox>
        <el-checkbox label="skuCode">SKU</el-checkbox>
        <el-checkbox label="name">品名</el-checkbox>
        <el-checkbox label="color">颜色</el-checkbox>
        <el-checkbox label="size">规格</el-checkbox>
      </el-checkbox-group>
      <template slot="footer">
        <el-button @click="saveProductNameSetting" type="primary" size="mini">确定</el-button>
        <el-button @click="settingDialogVisible=false" size="mini">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import money from '@/components/money.vue'
import mixinViewModule from '@/mixins/view-module'
import BigNumber from 'bignumber.js'
import { isNumber, moneyValidator } from '@/utils/validate'
import XLSX from 'xlsx'
import SelOrderDetailDialog from '@/views/modules/erp/order/detail/SelOrderDetailDialog.vue'

export default {
  mixins: [mixinViewModule],
  props: {
    agreementId: ''
  },
  components: { SelOrderDetailDialog,money },
  data () {
    return {
      productNameSetting:['code','skuCode','name','color','size'],
      settingDialogVisible:false,
      pageLoading: null,
      mixinViewModuleOptions: {
        getDataListURL: '/trade/agreement/detail/list',
        getDataListIsPage: false,
        activatedIsNeed: false,
      },
      dataForm: {
        agreementId: '',
        calculate: '1'
      },
      currentChange: null,
      exporting: false,
      detailRule: {
        money: [
          { validator: moneyValidator, trigger: 'change' },
        ],
        count: [
          {
            validator: function (rule, value, callback) {
              if (!isNumber(value)) {
                callback(new Error('请输入正确的数量'))
                return
              }
              callback()
            },
            trigger: 'change',
          },
        ]
      }
    }
  },
  watch: {
    agreementId: {
      handler: function (newVal) {
        if (newVal && newVal !== '') {
          this.dataForm.agreementId = newVal
          this.pageLoading = this.$loading()
          this.getDataList()
        } else {
          this.dataList = []
        }
      },
      immediate: true,
    },
  },
  mounted(){
    let productNameSetting=localStorage.getItem('product_name_setting')
    if(productNameSetting){
      this.productNameSetting=JSON.parse(productNameSetting)
    }
    console.log(this.productNameSetting)
  },
  methods: {
    getProductName(product){
      let defaultKeys=['code','skuCode','name','color','size']
      let fullNameAttr=[]
      defaultKeys.forEach(dk=>{
        if(!this.productNameSetting.find(k=>k===dk)){
          return
        }
        fullNameAttr.push(product[dk])
      })
      return fullNameAttr.join(' ')
    },
    saveProductNameSetting(){
      localStorage.setItem('product_name_setting',JSON.stringify(this.productNameSetting))
    },
    showSettingDialog(){
      this.settingDialogVisible=true
    },
    orderDetailSelected (e) {
      if (!e || e.length === 0) {
        return this.$message.error('未选择任何产品')
      }
      this.$confirm(`是否同步修改${e.length}个产品的实际单耗?`, '操作提示').then(() => {
        let postForm = []
        let needSaveBomList = this.currentChange.bomList.filter(bom => {
          return bom.type === 'bom' && (bom.otherAmount || bom.realCount !== bom.count)
        })
        console.log('needSaveBomList', needSaveBomList)
        needSaveBomList.forEach(bom => {
          e.forEach(od => {
            let tmp = {
              agreementDetailId: od.id,
              productId: bom.productId,
              realCount: bom.realCount,
              otherAmount: bom.otherAmount
            }
            postForm.push(tmp)
          })
        })
        this.$api.post(`/trade/bom/settle/batch_save`, postForm).then(res => {
          this.$message.success('保存成功')
          this.reload()
        })
      })
    },
    batchSaveBom (row) {
      this.currentChange = row
      this.$refs.SelOrderDetailDialog.init(this.agreementId)
    },
    // 导出table数据
    exportTableData (orderCode) {
      this.exporting = true
      this.$nextTick(() => {
        try {
          let book = XLSX.utils.book_new()
          for (let i = 0; i < this.dataList.length; i++) {
            let table = document.querySelector('#table' + i)
            let sheet = XLSX.utils.table_to_sheet(table)
            let product = this.dataList[i]
            // 品番号，规格，数量
            let sheetName = `【${product.checkInCount}】${this.getProductName(product)} `
            if(sheetName.length>25){
              sheetName=sheetName.substring(0,25)
            }
            sheetName=(i+1)+'.'+sheetName.replaceAll(`\\`,'').replaceAll('/','').replaceAll('?','').replaceAll('*','').replaceAll('[','').replaceAll(']','')
            XLSX.utils.book_append_sheet(book, sheet, sheetName)
          }
          XLSX.writeFile(book, `${orderCode}成本核价单${new Date().getTime()}.xlsx`)
        } catch (e) {
          console.log(e)
        } finally {
          this.exporting = false
        }
      })
    },
    //保存成本核价单实际单耗和调整金额
    async saveBomForSettle (data) {
      let postForm = data.filter(item => item.type === 'bom').map(item => {
        return {
          id: item.id,
          agreementId: item.agreementId,
          realCount: item.realCount,
          otherAmount: item.otherAmount
        }
      })
      try {
        const { data: res } = await this.$http.post(`/trade/bom/settle/save`, postForm)
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message.success('保存成功')
        this.reload()
      } catch (e) {
        console.log(e)
      }
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      sums[0] = '合计'
      let totalPrice = new BigNumber(0)
      if (!data || data.length === 0) {
        return sums
      }
      data.forEach((row) => {
        const rowTotalPrice = new BigNumber(row['totalPrice'])
        if (rowTotalPrice.isNaN()) {
          return
        }
        totalPrice = totalPrice.plus(rowTotalPrice)
      })
      sums[columns.length - 1] = totalPrice.toFixed(5)
      return sums
    },
    afterTableBinding () {
      this.pageLoading.close()
    },
    beforeTableBinding (dataList) {
      if (!dataList || dataList.length == 0) {
        return
      }
      dataList.forEach((item, pi) => {
        console.log('222',item.makeCost)
        if (!item.bomList) {
          item.bomList = []
        }
        item.hasBom = item.bomList.length > 0
        let tmpId = pi + 1
        item.bomList.push({
          id: tmpId++,
          name: '加工费',
          price: item.makeCost,
          count: 1,
          type: 'virtual'
        })
        item.bomList.push({
          id: tmpId++,
          name: '包装检品费',
          price: item.checkCost,
          count: 1,
          type: 'virtual'
        })
        item.bomList.push({
          id: tmpId++,
          name: '纸箱费',
          price: item.packCost,
          count: 1,
          type: 'virtual'
        })
        item.bomList.push({
          id: tmpId++,
          name: '中棉',
          price: item.cottonCost,
          count: 1,
          type: 'virtual'
        })

        //其他费用均摊
        if (item.otherCost) {
          item.otherCost = JSON.parse(item.otherCost)

          item.otherCost.forEach(cost => {
            item.bomList.push({
              id: cost.categoryName,
              name: cost.categoryName,
              price: cost.amount,
              count: 1,
              totalPrice: cost.amount,
              type: 'virtual'
            })
          })
        }
        item.bomList.forEach(bom => {
          let otherAmount = bom.otherAmount ? bom.otherAmount : 0
          let realCount = bom.realCount && bom.realCount > 0 ? bom.realCount : bom.count
          bom.totalPrice = new BigNumber(bom.price).multipliedBy(realCount).plus(otherAmount).toFixed(5)
          if (!bom.type) {
            bom.type = 'bom'
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.box-body {
  width: 100%;

  .product-list-box {
    margin: 10px;
    border: solid 1px #f1f4f5;

    .title {
      font-weight: 500;
      font-size: 16px;
      line-height: 150%;
      margin: 10px;
    }
  }
}
</style>
